import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class BlockTestimonySlider {
	static init() {

		let blocks = document.querySelectorAll('.block-testimony-slider');

		blocks.forEach((block) => {

			let swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".swiper-navigation-button-prev");
			const next = block.querySelector(".swiper-navigation-button-next");
			new Swiper(swiper, {
				slidesPerView: "1",
				navigation: {
					prevEl: prev,
					nextEl: next
				}
			});

		});

	}
}
